export default "__VITE_ASSET__db49223d__"